// Vardiya Yönetimi sayfası kullanım rehberi. Metinler 'guides' çeviri alanında.
import type { TFunction } from 'i18next';
import type { GuideContent } from '../../components/common/UsageGuideDialog';

const G = 'shifts.list';

export const shiftsListGuide = (t: TFunction): GuideContent => ({
  layout: 'tabbed',
  title: t(`${G}.title`, 'Vardiya Yönetimi nasıl kullanılır?'),
  intro: t(`${G}.intro`, 'Vardiya Yönetimi, şirketinizin (şube yöneticisiyseniz şubenizin) personel vardiyalarını yönetmenizi sağlayan araçları bir araya getirir. Haritada bir bölgeye tıklayarak o adıma geçebilirsiniz.'),
  navItems: [
    t(`${G}.nav.list`, 'Vardiya Listesi'),
    t(`${G}.nav.reports`, 'Giriş Çıkış Raporları'),
    t(`${G}.nav.total`, 'Toplam Süre'),
  ],
  regionLabels: {
    header: t(`${G}.regions.header`, 'Başlık, QR ve Excel düğmeleri'),
    tabs: t(`${G}.regions.tabs`, 'Sekmeler'),
    body: t(`${G}.regions.body`, 'Sekme içeriği'),
    footer: t(`${G}.regions.footer`, 'Sayfalama ve toplamlar'),
  },
  steps: [
    {
      region: 'tabs',
      title: t(`${G}.s1.title`, '1. Sekmeler arasında geçin'),
      text: t(`${G}.s1.text`, 'Sayfa üç sekmeden oluşur: Vardiya Listesi, Giriş Çıkış Raporları ve Toplam Süre. Başlık, açık olan sekmenin adını gösterir. Telefonda sekmeler yerine üstteki açılır listeden seçim yaparsınız.'),
    },
    {
      region: 'body',
      title: t(`${G}.s2.title`, '2. Vardiya Listesi: vardiyaları kurun'),
      text: t(`${G}.s2.text`, 'Bu sekmede vardiyaları oluşturur, düzenler ve yönetirsiniz. Her vardiya için giriş-çıkış saatleri, gecikme toleransları ve izleme (giriş/çıkış yöntemi) ayarları tanımlanır. Vardiya detaylarını ve her vardiyada çalışan personel sayısını burada görürsünüz.'),
      tips: [
        t(`${G}.s2.tip1`, '"Vardiya Ekle": Vardiya Adı, Giriş ve Çıkış Saati, Geç Kalma ve Erken Çıkma Toleransı (dk). Çıkış ertesi güne geçiyorsa gece vardiyası olarak işaretleyin.'),
        t(`${G}.s2.tip2`, 'Giriş/Çıkış Yöntemi: Tek QR – tek kod okutulur, giriş mi çıkış mı olduğu saat penceresine göre otomatik belirlenir. Çift QR – Giriş ve Çıkış kodları ayrı okutulur, gün içinde birden fazla oturum desteklenir.'),
        t(`${G}.s2.tip3`, '"Personel Ata" ile vardiyaya personel ekler, kaldırır veya değiştirirsiniz. Bir personel yalnız bir vardiyada olabilir; başka vardiyaya atanmış personel listede görünmez.'),
        t(`${G}.s2.tip4`, 'Personel atanmış vardiya silinemez; önce vardiyadaki tüm personeli kaldırın.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s3.title`, '3. Giriş Çıkış Raporları: kayıtları izleyin'),
      text: t(`${G}.s3.text`, 'Personelin vardiyalara giriş-çıkış kayıtlarını görürsünüz: hangi personelin hangi vardiyada çalıştığı, giriş-çıkış saatleri ve durum bilgisi (Normal Geldi, Geç Geldi, Erken Çıktı vb.). Son 30 günün kayıtları otomatik olarak gösterilir.'),
      tips: [
        t(`${G}.s3.tip1`, 'Personel veya vardiya adıyla arayın; durum, şube ve tarih (Bugün, Dün, Bu Hafta, Son 30 Gün ya da başlangıç–bitiş) filtreleriyle daraltın.'),
        t(`${G}.s3.tip2`, 'Giriş ve çıkış hücrelerindeki cihaz simgesine tıklayınca işlemin yapıldığı cihaz ve konum bilgileri açılır.'),
      ],
    },
    {
      region: 'body',
      title: t(`${G}.s4.title`, '4. Toplam Süre: çalışma sürelerini görün'),
      text: t(`${G}.s4.text`, 'Personelin seçtiğiniz tarih aralığındaki toplam çalışma sürelerini görürsünüz. Personel ve tarih aralığı seçip "Filtrele" ile özel raporlar oluşturun; toplam çalışma süresi, fazla mesai süreleri ve diğer istatistikler ayrıntılı olarak listelenir.'),
      tips: [
        t(`${G}.s4.tip1`, '"Tüm personeli seç" ile herkesi tek raporda görebilirsiniz; gelinmeyen günler "Gelmedi" olarak gösterilir.'),
      ],
    },
    {
      region: 'footer',
      title: t(`${G}.s5.title`, '5. Sayfalar ve toplamlar'),
      text: t(`${G}.s5.text`, 'Uzun raporlarda alttaki sayfalama ile ilerler, sayfa başına satır sayısını seçersiniz. Rapor tablolarının altında genel toplam satırı yer alır.'),
    },
    {
      region: 'header',
      title: t(`${G}.s6.title`, '6. Excel ve QR düğmeleri'),
      text: t(`${G}.s6.text`, '"Excel İndir" açık sekmedeki verileri Excel dosyası olarak indirir; dosya görüntülenen kayıtları ve uygulanan filtreleri içerir.'),
      tips: [
        t(`${G}.s6.tip1`, '"QR İndir" (şube yöneticisinde "Şube QR") şirketinize veya şubenize özel QR kodu oluşturup indirir. Personel bu kodu mobil uygulamada okutarak giriş-çıkış yapar.'),
        t(`${G}.s6.tip2`, '"QR Tasarla" ile QR kodunu yazdırılabilir bir tasarıma yerleştirirsiniz.'),
        t(`${G}.s6.tip3`, 'Başlıktaki (i) düğmesi bu rehberi her zaman yeniden açar.'),
      ],
    },
  ],
});
